import {mapActions, mapState} from "vuex";
import notifyMessages from "./notifyMessages";

export default {

  mixins: [ notifyMessages ],

  methods: {
    ...mapActions({
      exportResource: 'booleanSearch/exportResource',
      exportTags: 'booleanSearch/exportTags'
    }),

    getItemIds(item) {
      if (typeof item === 'object' && Object.keys(item).length){
        item = Object.values(item).reduce((acc, data) => {
          const ids = Array.from(data.tags.keys());
          return acc.concat(ids);
        }, []);} else if (typeof item == 'object'){
          item = [];
        } else {
          item = [item];
        }
        return item;
    },

    exportSearches({ key, item, formatType, filters }) {
      if(['group', 'group_library'].indexOf(key) !== -1) {
        return;
      }

      if(['tagSearch', 'tag_library'].indexOf(key) == -1) {
        if(key === 'searches'){
          item = this.getItemIds(item);
        }
        return new Promise((resolve, reject) => {
          this.exportResource({ item, formatType, key, filters })
            .then(() => {
              this.notifyStoreSuccess(this.$tc('booleanSearch.export_success_message', item ? 1 : 2));
              resolve();
            })
            .catch(() => {
              this.notifyStoreError(this.$tc('booleanSearch.export_error_message', item ? 1 : 2));
              reject();
            });
        })
      } else {
        item = this.getItemIds(item);
        return new Promise((resolve, reject) => {
          this.exportTags({ item, formatType, filters })
            .then(() => {
              this.notifyStoreSuccess(this.$tc('booleanSearch.tagSearch_export_success_message', item ? 1 : 2));
              resolve();
            }).catch(() => {
              this.notifyStoreError(this.$tc('booleanSearch.tagSearch_export_error_message', item ? 1 : 2));
              reject();
            });
        });
      }
    }
  }
}